<template>
  <div @click="clickFn" :class="['button', type]">
    <slot v-if="noWrap"></slot>
    <div v-else style="margin-bottom: 4px;">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      default: 'default'
    },
    jump: {
      default: ''
    },
    noWrap: {
      default: false
    }
  },
  data () {
    return {
    }
  },
  methods: {
    clickFn () {
      this.$emit('click')
    }
  }
};
</script>

<style lang="scss">
@media screen and (min-width: $mimViewWidth) {
  @import "@/assets/scss/components/Button.scss";
}
@media screen and (max-width: $maxViewWidth) {
  @import "@/assets/scss/components/m/Button.scss";
}
</style>
